import { useEffect, Card } from 'external/react'


import {capitalizeFirstLetter} from 'utilities/text'

import useAuth from 'context/auth-context/hook'
import useFormValidation, {validators}  from 'utilities/form-validation'

import useParent from 'context/parent-context/hook'

import { supportService } from 'services/support.service'
import { notifyError, notifySuccess } from 'components/Notify'

import DreyfousLocation from './DreyfousLocation'
import SupportRequestButton from './SupportRequestButton'
import SupportForm from './SupportForm'


const { createEmailValidation, createRequiredFieldValidation, createPhoneValidation} = validators

const supportValidations = {
	name: [createRequiredFieldValidation('name')],
	email: [createRequiredFieldValidation('email'), createEmailValidation('email')],
	phone: [createRequiredFieldValidation('phone'), createPhoneValidation('phone')],
	message: [createRequiredFieldValidation('message')]
}

export default function Support() {

	const {user} = useAuth()
	const {supportForm: support, update} = useParent()

	const [errors, validate, resetErrors] = useFormValidation(supportValidations);

	const cleanEntity = () => {
		const {id, first_name, last_name, email} = user
		const name = `${capitalizeFirstLetter(first_name)} ${capitalizeFirstLetter(last_name)}`
		const cleanedForm = {id, name, first_name, last_name, email, message: ''}
		resetErrors()
		update({supportForm: {$shallow: cleanedForm}})
	}

	async function handleSubmitRequestClick (e: { preventDefault: () => void }) {
		e.preventDefault()

		if (!validate(support, true)) return;
		const response = await supportService.sendEmail(support);

		if (response.data.success) {
			notifySuccess('Mensaje enviado exitosamente.')
			cleanEntity();
		} else {
			notifyError('Error al enviar el correo.')
		}
	}


	useEffect(() => { validate(support, false)}, [support])
	useEffect(() => { if (user.id) { cleanEntity() } }, [user])

	return (
		<>
			<Card.Body className='d-flex flex-column'>
			<div className='d-flex flex-grow-1 gap-4'>
				<div className='d-flex flex-grow-1 flex-column'>
					<SupportForm errors={errors} />
				</div>
				<div className='d-flex flex-grow-1 pb-4 flex-column'>
					<DreyfousLocation />
				</div>
			</div>
			</Card.Body>
			<Card.Footer className='text-muted bg-white text-right'>
				<SupportRequestButton onClick={handleSubmitRequestClick} />
			</Card.Footer>
		</>
	)
}